import { connect } from 'react-redux'
import { IGlobalState } from '../../../../Root/store/appReducer'
import {
  deleteUser,
  getCompanyUsers,
  setCompanyUsersLoading,
  setUserCountry,
  setUserDivision,
  toggleUserStatus,
} from '../../store/UserManagementActions'
import { getCompanyUsersList, getCompanyUsersLoading } from '../../store/UserManagementSelectors'
import UserManagement, { IUserManagementDispatchProps } from './UserManagement'
import {
  companyCountriesSelector,
  companyDivisionsSelector,
  managedCompaniesSelector,
} from '../../../Settings/store/SettingsSelectors'
import { getUserCompanyCountries, getCompanyDivisions } from '../../../Settings/store/SettingsActions'

const mapStateToProps = (state: IGlobalState) => ({
  companyUsers: getCompanyUsersList(state),
  usersLoading: getCompanyUsersLoading(state),
  divisions: companyDivisionsSelector(state),
  countries: companyCountriesSelector(state),
  managedCompanies: managedCompaniesSelector(state),
})

const mapDispatchToProps: IUserManagementDispatchProps = {
  deleteUser,
  getCompanyUsers,
  getUserCompanyCountries,
  getCompanyDivisions,
  toggleUserStatus,
  setUserCountry,
  setUserDivision,
  setCompanyUsersLoading,
}

export default connect(mapStateToProps, mapDispatchToProps)(UserManagement)
